export default "__VITE_ASSET__Ct6Jzrl0__"